var community = "https://shopfront-cdn.tekoapis.com/static/c71967f1b568ff35.svg";

export { community as default };
